<template>
  <v-dialog
    max-width="800px"
    width="100%"
    v-model="dialog"
    scrollable
    @keydown.esc="close"
  >
    <v-card :loading="loading">
      <v-system-bar window color="info" dark class="mb-2">
        Stundenplan Wünsche
        <v-spacer />
        <v-btn @click="dialog = false" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>

      <v-card-text>
        <RowItem align="center" title="Person">
          <PersonItem :value="wish.teacher" />
        </RowItem>
        <RowItem align="center" title="Semester" v-if="wish.term">
          <StaticText :value="wish.term.fullText" />
        </RowItem>
        <RowItem title="Unterricht">
          <StaticText :value="wish.employment" /> %
        </RowItem>
        <v-subheader class="mt-4">Allgemein</v-subheader>
        <RowItem title="freie Halbtage  ">
          <StaticText :value="wish.halfdays" />
        </RowItem>
        <RowItem title="freie Ganztage  ">
          <StaticText :value="wish.fulldays" />
        </RowItem>
        <v-subheader class="mt-4">Kurse</v-subheader>
        <RowItem
          v-for="course in wish.wishCourses"
          :key="course.id"
          :title="course.description"
        >
          <StaticText :value="course.comment" />
        </RowItem>
        <v-subheader class="mt-4">Sperrungen</v-subheader>
        <RowItem
          v-for="slot in wish.wishSlots.filter((s) => s.forced)"
          :key="slot.id"
          :title="slot.day + ' ' + slot.time"
        >
          <StaticText :value="slot.comment" />
        </RowItem>
        <v-subheader class="mt-4">Wünsche</v-subheader>
        <RowItem
          v-for="slot in wish.wishSlots.filter((s) => !s.forced)"
          :key="slot.id"
          :title="slot.day + ' ' + slot.time"
        >
          <StaticText :value="slot.comment" />
        </RowItem>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text block color="error" @click="close">Schliessen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { defineComponent } from "vue";

import PersonItem from "common/components/PersonItem.vue";
import RowItem from "@/components/RowItem";
import StaticText from "common/components/StaticText.vue";

export default defineComponent({
  name: "WishDetails",
  components: { PersonItem, RowItem, StaticText },
  data() {
    return {
      dialog: true,
      loading: false,
      wish: { wishCourses: [], wishSlots: [] },
    };
  },
  computed: {},
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$router.back();
      }
    },
  },
  methods: {
    close() {
      this.$router.back();
    },
    async fetchData() {
      this.loading = true;
      this.wish = await this.apiGet({
        resource: "teacher/wish",
        id: this.$route.params.id,
      });
      this.loading = false;
    },
  },

  async created() {
    this.fetchData();
  },
});
</script>
